import React from "react";
import ErrorField from "./error";
import { TextField } from "components/support";
import { observer } from "mobx-react";

const CfopField = ({ errors, row, onChange }) => {
  const { taxes } = row;
  const foundErrors = errors.find(v => v.name === row.name);
  const hasErrors =
    foundErrors &&
    !!foundErrors.errors &&
    !!foundErrors.errors.taxes &&
    !!foundErrors.errors.taxes.cfop;

  return (
    <div>
      <TextField
        value={taxes.cfop}
        onChange={(_, value) => onChange(value.replace(/\D/g, ""))}
        fullWidth
      />
      {hasErrors && <ErrorField error={foundErrors.errors.taxes.cfop} />}
    </div>
  );
};

export default observer(CfopField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/cfop.js